import { Component } from '@angular/core';
@Component({
  standalone: false,
  selector: 'app-mandatory-check-chip',
  templateUrl: './mandatory-check-chip.component.html',
  styleUrls: ['./mandatory-check-chip.component.scss'],
})
export class MandatoryCheckChipComponent {}
